<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="Maklumat Pengguna">
    <z-page :title="user.name" icon="fal fa-user">
      <template #buttons>
        <w-button
          icon="fal fa-circle"
          text
          md
          class="ml0"
          color="success"
        ></w-button>
      </template>

      <w-card bg-color="z-pale-blue" class="mt4">
        <w-flex justify-center align-center>
          <div class="xs3">
            <w-image
              class="maa sh1 bdrsr d-block"
              src="/images/avatar.png"
              :width="100"
              :height="100"
            >
            </w-image>
          </div>
          <div class="xs12">
            <w-flex class="mt3">
              <div class="xs4">
                <h5 class="fw-semibold m0">Nama :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ user.no_id }} | {{ user.name }}
                </div>
              </div>

              <div class="xs4">
                <h5 class="fw-semibold m0">No. Telefon :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ user.phone_number }}
                </div>
              </div>
              <div class="xs3">
                <h5 class="fw-semibold m0">Emel :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ user.email }}
                </div>
              </div>
            </w-flex>

            <w-flex class="mt3 mb4">
              <div class="xs4">
                <h5 class="fw-semibold m0">Jawatan :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ user.jawatan }}
                </div>
              </div>
              <div class="xs4">
                <h5 class="fw-semibold m0">Tarikh Daftar :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ $zutil.dateformat(user.created_at) }}
                </div>
              </div>
              <div class="xs4">
                <h5 class="fw-semibold m0">Tarikh Kemas Kini :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ $zutil.dateformat(user.updated_at) }}
                </div>
              </div>
            </w-flex>
            <w-flex class="mt3 mb4">
              <div class="xs4">
                <h5 class="fw-semibold m0">Status :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ user.status_keterangan }}
                </div>
              </div>
              <div class="xs4">
                <h5 class="fw-semibold m0">Jabatan :</h5>
                <div class="fw-normal my1 fs-1">
                  {{ user.jabatan_keterangan }}
                </div>
              </div>
              <!--  <div class="xs4">
                                <h5 class="fw-semibold m0">Borang Permohonan :</h5>
                                <div class="fw-normal my1 fs-1">
                                    <a :href="user.permohonan_url">{{ user.permohonan_nama }}</a>
                                </div>
                            </div>
                             <div class="xs4">
                                <h5 class="fw-semibold m0">Salinan Kad Pengenalan :</h5>
                                <div class="fw-normal my1 fs-1">
                                    <a :href="user.ic_url">{{ user.ic_nama }}</a>
                                </div>
                            </div> -->
            </w-flex>
            <!-- <w-flex class="mt3 mb4">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Status :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ user.status_keterangan }}
                                </div>
                            </div>
                        </w-flex> -->
            <w-flex class="mt3 mb4">
              <template
                v-if="
                  $zutil.can('ADMIN_JABATAN') ||
                  $zutil.can('SuperAdmin Jabatan')
                "
              >
                <div class="xs12 text-right pt5">
                  <template
                    v-if="
                      user.status == 2
                    "
                  >
                    <template v-if="user.permissions != 0 || user.roles != 0">
                      <w-button
                        class="ml1"
                        v-on:click="status(3)"
                        bg-color="warning"
                      >
                        Sahkan
                      </w-button>
                    </template>
                    <template v-else>
                      <w-tooltip
                        left
                        align-bottom
                        color="white"
                        bg-color="blue"
                      >
                        <template #activator="{ on }">
                          <span v-on="on">
                            <w-button
                              class="ml1"
                              :disabled="true"
                              bg-color="warning"
                            >
                              Sahkan
                            </w-button>
                          </span>
                        </template>
                        Isikan Peranan Atau Kebenaran Untuk Sahkan Pengguna
                      </w-tooltip>
                    </template>
                    <w-button class="ml1" @click="inactive()">
                      Tidak Sahkan
                    </w-button>
                  </template>
                </div>
              </template>

              <template v-if="$zutil.can('ADMIN_BENDAHARI')">
                <template v-if="user.status == 3">
                  <div class="xs12 text-right pt5">
                    <w-button
                      class="ml1"
                      v-on:click="status(1)"
                      bg-color="warning"
                    >
                      Lulus
                    </w-button>

                    <w-button class="ml1" v-on:click="status(4)">
                      Tidak Lulus
                    </w-button>
                  </div>
                </template>
              </template>
              <template v-if="$zutil.can('ADMIN_BENDAHARI')">
                <template v-if="user.status ==1">
                  <div class="xs12 text-right pt5">
                    <w-button class="ml1" v-on:click="status(4)">
                      Tidak Aktif
                    </w-button>
                  </div>
                </template>
              </template>
              <template v-if="$zutil.can('ADMIN_BENDAHARI')">
                <template v-if="user.status ==4">
                  <div class="xs12 text-right pt5">
                    <w-button class="ml1" v-on:click="status(1)"  bg-color="warning">
                        Aktif
                    </w-button>
                  </div>
                </template>
              </template>
            </w-flex>
          </div>
        </w-flex>

        <w-tabs :items="tabs" :no-slider="false" active-class="primary">
          <template #item-content.1>
            <permission
              title="Senarai Peranan"
              :user="user"
              :items="roles"
              which="role"
              v-model:selected="user.roles_id"
            >
            </permission>
          </template>

          <template #item-content.2>
            <permission
              title="Senarai Kebenaran"
              :user="user"
              :items="permissions"
              which="permission"
              v-model:selected="user.permissions_id"
            >
            </permission>
          </template>

          <template #item-content.4>
            <z-jejak-audit :jejak_audit="user.jejak_audit" />
            <!-- <w-flex justify-center align-center>
        <div class="w-card__content content-hardcode">
            <table class="table-dashboard" width="100%">
                <thead>
                  <tr>
                    <td width="2%">No</td>
                    <td width="15%">Tarikh</td>
                    <td>Pengguna</td>
                    <td>Tindakan</td>
                    <td>Catatan</td>
                  </tr>
                </thead>
                <tbody>

                </tbody>
            </table>
        </div>
      </w-flex>
        <w-flex class="mt3" wrap align-center justify-end>
          <w-button class="my1" bg-color="warning" dark  @click="back()" >Kembali</w-button>
        </w-flex>   -->
          </template>
          <template #item-content.3>
            <w-flex justify-center align-center>
              <div class="w-card__content content-hardcode">
                <table class="table-dashboard" width="100%">
                  <thead>
                    <tr>
                      <td width="2%">No</td>
                      <td>Lampiran</td>
                      <td width="15%">Tarikh</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dt, index) in user.lampiran">
                      <td class="w-table__cell text-left">
                        {{ index + 1 }}
                      </td>
                      <td class="w-table__cell text-left">
                        <a :href="dt.url"> {{ dt.nama }}</a>
                      </td>
                      <td class="w-table__cell text-left">
                        {{ $zutil.dateformat(dt.created_at) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </w-flex>
            <w-flex class="mt3" wrap align-center justify-end>
              <w-button class="ml1" @click="lampiran()"> Muat Naik </w-button
              >&nbsp;&nbsp;
              <w-button class="my1" bg-color="warning" dark @click="back()"
                >Kembali</w-button
              >
            </w-flex>
          </template>
        </w-tabs>
      </w-card>
    </z-page>

    <w-dialog
      v-model="dialogLampiran.show"
      :fullscreen="dialogLampiran.fullscreen"
      :width="dialogLampiran.width"
      :persistent="dialogLampiran.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-light1--bg white"
    >
      <template #title>
        <w-icon class="mr2">fal fa-user</w-icon>
        Muat Naik
      </template>
      <w-form
        ref="form"
        class=""
        v-model="form.valid"
        v-model:errors-count="form.errorsCount"
        validate="upload"
        @success="onSuccess"
      >
        <w-flex justify-space-between class="mb4">
          <w-input
            class="mt3"
            style="margin-left: 10px"
            type="file"
            placeholder="Sila Muatnaik Borang Permohonan"
            required
            v-model="files"
            label="Borang Permohonan"
          />
        </w-flex>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button
          class="my1"
          bg-color="primary"
          dark
          :disabled="form.valid === false"
          :loading="form.submitted && !form.sent"
          @click="upload"
        >
          Hantar
        </w-button>
        &nbsp;&nbsp;
        <w-button
          bg-color="grey-light5--bg"
          @click="dialogLampiran.show = false"
          >Tutup</w-button
        >
      </template>
    </w-dialog>

    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-light1--bg white"
    >
      <template #title>
        <w-icon class="mr2">fal fa-user</w-icon>
        Catatan Tidak Sahkan
      </template>
      <w-form
        class=""
        v-model="form.valid"
        v-model:errors-count="form.errorsCount"
        @validate="onValidate"
        @success="onSuccess"
      >
        <w-flex justify-space-between class="mb4">
          <z-input
            label="Catatan *"
            name="catatan_batal"
            v-model="form.catatan_batal"
            :validators="[validators.required]"
          />
        </w-flex>
        <w-flex justify-space-between class="mb4">
          <w-input
            v-model="form.tarikh_tamat"
            required
            label="Tarikh Tamat"
            type="date"
            :validators="[validators.required]"
          />
        </w-flex>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button
          class="my1"
          bg-color="primary"
          dark
          :disabled="form.valid === false"
          :loading="form.submitted && !form.sent"
          @click="send(4)"
        >
          <w-icon dark tile class="mr2">fal fa-times</w-icon> Hantar
        </w-button>
        &nbsp;&nbsp;
        <w-button bg-color="grey-light5--bg" @click="dialog.show = false"
          >Tutup</w-button
        >
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from "vue";
import Permission from "./Subs/Permission.vue";
import ZResource from "@/Modules/z-resource";

export default {
  extends: ZResource,
  components: {
    Permission,
  },
  props: {
    user: [Array, Object],
    status_id: [Array, Object],
    roles: [Array, Object],
    permissions: [Array, Object],
  },
  data() {
    return {
      resourceurl: "admin",
      success: "",
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: this.$page.props.app_name, route: "/sitemap" },
        { label: "Utama", route: "/" },
        { label: "Pentadbiran", route: "/admin" },
        { label: "Pengguna", route: "/admin/user" },
        { label: this.user.name, route: "/admin/user" },
      ],
      tabs: [
        { title: "Peranan", content: "" },
        { title: "Kebenaran", content: "Pipizola" },
        { title: "Lampiran", content: "" },
        { title: "Jejak Audit", content: "" },
      ],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1000,
      },
      dialogLampiran: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1000,
      },
    };
  },
  methods: {
    status(id) {
      this.$inertia.get("status/" + this.user.id + "/" + id);
    },

    send(id) {
      this.form.id = id;
      this.form.user_id = this.user.id;
      this.form.email = this.user.email;
      this.form.no_id = this.user.no_id;

      this.$zcomm
        .post(this.resourceurl + ".batal", this.form)
        .then((res) => {
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit();
          }
          // this.$zutil.notify("Rekod telah berjaya disimpan");
          this.dialog.show = false;
        })
        .catch((err) => {})
        .finally(() => {});
      this.dialog.show = false;
    },

    upload(id) {
      let formData = new FormData();
      formData.append("file", this.files[0].file);
      formData.append("model", "App\\Models\\User");
      formData.append("model_id", this.user.id);
      this.$zcomm
        .post(this.resourceurl + ".upload", formData)
        .then((res) => {
          if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd();
          }
          this.$zutil.notify("Lampiran Telah Berjaya Di Muat Naik");
          this.dialogLampiran.show = false;
        })
        .catch((err) => {})
        .finally(() => {});
      this.dialogLampiran.show = false;
    },
    lampiran() {
      this.dialogLampiran.show = 1;
    },
    inactive() {
      this.dialog.show = 1;
    },
  },

  watch: {},
  mounted() {},
};
</script>
